import React from 'react';
import { ArrowUpRight, BookOpen, Compass, Feather, HeartHandshake, HelpCircle, Library, PlayCircle, Sparkles } from 'lucide-react';
import { Link } from 'react-router';
import ScreenLayout from './ScreenLayout';

const resourceGroups = [
    {
        title: 'Begin here',
        description: 'Simple practices already inside your prayer app.',
        icon: Sparkles,
        resources: [
            { title: 'Daily Prayer', description: 'A calm Scripture, prayer, and reflection for today.', to: '/prayers', label: '5 minute practice', icon: HeartHandshake },
            { title: 'Daily Devotional', description: 'Read slowly, reflect, and carry one truth with you.', to: '/daily-devotional', label: 'Guided reading', icon: Feather },
            { title: 'Bible Reader', description: 'Read the complete verified World English Bible.', to: '/bible-reader', label: '66 books', icon: BookOpen }
        ]
    },
    {
        title: 'Build a rhythm',
        description: 'Tools for making prayer part of ordinary days.',
        icon: Compass,
        resources: [
            { title: 'Prayer Timer', description: 'Create an unhurried space for stillness and prayer.', to: '/timer', label: 'Choose your time', icon: PlayCircle },
            { title: 'Prayer Journal', description: 'Keep gratitude, reflections, and answered prayers together.', to: '/journal', label: 'Write & remember', icon: Library },
            { title: 'Prayer Requests', description: 'Hold people and needs close as you pray.', to: '/requests', label: 'Your prayer list', icon: HeartHandshake }
        ]
    }
];

const Resources = () => (
    <ScreenLayout title="Prayer Resources" icon={HelpCircle}>
        <section className="resources-hero">
            <p className="shared-kicker"><Library size={14} /> Your practice library</p>
            <h1>Small steps for a deeper prayer life.</h1>
            <p>Choose one place to begin. Each resource is designed to be useful without feeling like homework.</p>
        </section>

        <div className="resources-groups">
            {resourceGroups.map((group) => (
                <section className="resources-group" key={group.title}>
                    <header>
                        <span><group.icon size={20} /></span>
                        <div><h2>{group.title}</h2><p>{group.description}</p></div>
                    </header>
                    <div className="resources-grid">
                        {group.resources.map((resource) => (
                            <Link className="resource-library-card" to={resource.to} key={resource.title}>
                                <span className="resource-library-icon"><resource.icon size={21} /></span>
                                <div>
                                    <small>{resource.label}</small>
                                    <h3>{resource.title}</h3>
                                    <p>{resource.description}</p>
                                </div>
                                <ArrowUpRight size={18} />
                            </Link>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    </ScreenLayout>
);

export default Resources;
